var path = '/components/directives/customfield/media_image.tpl.html';
var html = "<al-media-form-field\n        current-selected-file=\"field.ngModel\"\n        on-file-select=\"field.updateFileModel(file)\"\n        start-directory-uuid=\"field.definition.startDirectory\"\n        field-label=\"field.definition.name\"\n        allowed-types=\"['image']\"\n        size=\"field.definition.fieldSize || 'small'\"\n        allowed-mimes=\"[]\"></al-media-form-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/media_image.tpl.html
// module id = 1995
// module chunks = 1